import { z } from 'zod';

export const formSchema = z.object({
  titulo: z.string().min(3, 'El título debe tener al menos 3 caracteres',),
  subtitulo: z.string().min(3, 'El subtítulo debe tener al menos 3 caracteres',),
})